const labelsCreate = {
  'label created': true,
  waitingLabel: true,
  labelPreprint: true,
};

export function isLabelCreated(label) {
  return labelsCreate[label] || false;
}
